import { CButton, CCardBody, CCardHeader, CCol, CRow } from "@coreui/react";
import React from "react";
// import usersData from "../users/UsersData";

const BidderUploadedDetails = () => {
  return (
    <>
      <CCardHeader className="shadow-sm">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Bidder Details</h3>
          </CCol>
        </CRow>
        <hr />
        <CCardBody>
          <CRow>
            <CCol xl={3}>
              <label for="loginid">Login Id : </label>
              <input type="text" className="form-control" id="loginid" />
            </CCol>
            <CCol xl={3}>
              <label for="companyname">Company Name : </label>
              <input type="text" className="form-control" id="companyname" />
            </CCol>
          </CRow>
          <CRow className="mt-2">
            <CCol xl={3}>
              <label for="lotno">Tender Category : </label>{" "}
              <input type="text" className="form-control" id="lotno" />
            </CCol>
            <CCol xl={3}>
              <label for="purchaseratepersb">Propritor Name : </label>{" "}
              <input
                type="text"
                className="form-control"
                id="purchaseratepersb"
              />
            </CCol>
          </CRow>
          <CRow className="mt-2">
            <CCol xl={3}>
              <label for="lotno">Propritor Name</label>{" "}
              <input type="text" className="form-control" id="lotno" />
            </CCol>

            <CCol xl={3}>
              <label for="purchaseratepersb">Lot number: </label>{" "}
              <input
                type="text"
                className="form-control"
                id="purchaseratepersb"
              />
            </CCol>
          </CRow>
          <CRow className="mt-2">
            <CCol xl={3}>
              <label for="lotno">Purchase Rate per S.B. (In Rs.)</label>{" "}
              <input type="text" className="form-control" id="lotno" />
            </CCol>
            <CCol xl={3}>
              <label for="purchaseratepersb">
                Purchase Price (In Rs.) (Quantity * Rate)
              </label>{" "}
              <input
                type="text"
                className="form-control"
                id="purchaseratepersb"
              />
            </CCol>
          </CRow>
          <CRow className="mt-2">
            <CCol xl={3}>
              <label for="lotno">Uploaded Document :</label>
              <CButton type="submit" className="row ml-2  btn btn-success ">
                Download
              </CButton>
            </CCol>
            <CCol xl={3}>
              <label for="purchaseratepersb">Payment Mode </label>{" "}
              <input
                type="text"
                className="form-control"
                id="purchaseratepersb"
              />
            </CCol>
          </CRow>
          <CRow className="mt-5">
            <CCol>
              <CButton type="submit" className="btn btn-success mr-2">
                Approve
              </CButton>
              <CButton type="submit" className="btn btn-success">
                Reject
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCardHeader>
    </>
  );
};
export default BidderUploadedDetails;
